<div class="md:m-auto flex flex-col gap-4 my-auto px-[45px] md:px-[90px] w-full">
  <div class="flex flex-col items-center justify-evenly">
    <img class="mb-2 h-[42px] w-[42px]" src="assets/images/cookie.svg" alt="cookie" />
    <div class="text-center text-2xl font-semibold text-primary md:text-3xl">
      {{ 'CookiesConsentDialog.Title' | translate }}
    </div>
</div>

  <mat-dialog-content class="!p-0">
    <div class="text-center font-medium" dir="auto">
      <span>
        {{ 'CookiesConsentDialog.Content' | translate }}
      </span>
      <span class="cursor-pointer text-[#4E57A9] hover:underline" (click)="openLink()">
        {{ 'CookiesConsentDialog.TermOfUseLink' | translate }}
      </span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <div class="flex flex-col items-center justify-evenly">
      <a
        class="mat-ripple flex h-12 w-40 flex-shrink-0 cursor-pointer items-center justify-center rounded-full bg-primary text-white"
        type="button"
        (click)="approve()"
        matRipple
      >
        <span>
          {{ 'CookiesConsentDialog.Approve' | translate }}
        </span>
      </a>
      <a
        class="mat-ripple flex h-12 w-40 flex-shrink-0 cursor-pointer items-center justify-center rounded-full bg-white text-primary"
        type="button"
        (click)="disapprove()"
        matRipple
      >
        <span>
          {{ 'CookiesConsentDialog.Declined' | translate }}
        </span>
      </a>
    </div>
  </mat-dialog-actions>
</div>
